import { Provider } from 'react-redux';
import './App.css';
import AppRoutes from "./router/Routes";
import store from './redux/Store';
import ScrollTopButton from './scrolltop/ScrollTopButton';

function App() {
  return (
    <>  
        <Provider store={store}> 
             <AppRoutes />
        </Provider>
        <ScrollTopButton/>
    </>
  );
}
export default App;